import { useTranslation } from "react-i18next";
import { Col, Form, Row } from "react-bootstrap";
import { SurveyQuestion } from "../../../types";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../redux/store";

interface SurveyQuestionAnswerProps {
    index: number;
    updateQuestionField: (index: number, field: keyof SurveyQuestion, value: any) => void; 
}

export default function SurveyQuestionAnswerNumber({ index, updateQuestionField }: SurveyQuestionAnswerProps) {
    const { t } = useTranslation(['surveyAdmin', 'common']);
    const question = useSelector((state: RootState) => state.surveyForm.data.questions[index]);

    return (
        <Row>
            <Col md={9}>
                <Row>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("surveyAdmin:dafaultValue")}</Form.Label>
                            <Form.Control
                                type="number"
                                min={question.minimumValue}
                                max={question.maximumValue}
                                value={question.numberDefaultValue ?? ""}
                                onChange={(e) => updateQuestionField(index, 'numberDefaultValue', e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("surveyAdmin:minimumValue")}</Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                max={100}
                                value={question.minimumValue ?? ""}
                                onChange={(e) => updateQuestionField(index, 'minimumValue', e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("surveyAdmin:maximumValue")}</Form.Label>
                            <Form.Control
                                type="number"
                                min={question.minimumValue}
                                max={100}
                                value={question.maximumValue ?? ""}
                                onChange={(e) => updateQuestionField(index, 'maximumValue', e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("surveyAdmin:numberOfDecimals")}</Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                value={question.numberOfDecimals ?? 0}
                                onChange={(e) => updateQuestionField(index, 'numberOfDecimals', e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}